import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
     fetchEventsRequest,
     fetchEventsSuccess,
     fetchEventsFailure,
     fetchEventDetailsRequest,
     fetchEventDetailsSuccess,
     fetchEventDetailsFailure,
     registerEventRequest,
     registerEventSuccess,
     registerEventFailure,
} from './eventSlice';
import { fetchEvents, fetchEventDetails, registerForEvent } from '../services/api';

function* fetchEventsSaga() {
     try {
          const response = yield call(fetchEvents);
          yield put(fetchEventsSuccess(response.data));
     } catch (error) {
          const message = error.response?.data?.detail || error.response?.data?.message || (error.response ? `Server error (${error.response.status})` : 'Unable to connect to the server. Please check your internet connection and try again.');
          yield put(fetchEventsFailure(message));
     }
}

function* fetchEventDetailsSaga(action) {
     try {
          const response = yield call(fetchEventDetails, action.payload);
          yield put(fetchEventDetailsSuccess(response.data));
     } catch (error) {
          const message = error.response?.data?.detail || error.response?.data?.message || (error.response?.status === 404 ? 'This event could not be found. It may have been removed or the link is incorrect.' : error.response ? `Server error (${error.response.status})` : 'Unable to connect to the server. Please check your internet connection and try again.');
          yield put(fetchEventDetailsFailure(message));
     }
}

function* registerEventSaga(action) {
     try {
          const { eventId, payload } = action.payload;
          const response = yield call(registerForEvent, eventId, payload);
          yield put(registerEventSuccess(response.data));
     } catch (error) {
          const message = error.response?.data?.detail || error.response?.data?.message || error.message;
          yield put(registerEventFailure(message));
     }
}

function* watchFetchEvents() {
     yield takeLatest(fetchEventsRequest.type, fetchEventsSaga);
}

function* watchFetchEventDetails() {
     yield takeLatest(fetchEventDetailsRequest.type, fetchEventDetailsSaga);
}

function* watchRegisterEvent() {
     yield takeLatest(registerEventRequest.type, registerEventSaga);
}

export default function* rootSaga() {
     yield all([watchFetchEvents(), watchFetchEventDetails(), watchRegisterEvent()]);
}
